module.exports = "<span class=toggle-translated-text ng-show=!$ctrl.isMainLang() ng-class=\"{'icon-arrow-up': !$ctrl.collapsed, 'icon-arrow-down': $ctrl.collapsed}\" ng-click=$ctrl.toggleCollapse() title=\"{{ 'Show/hide main language text' | translate }}\"> </span> <p ng-show=!$ctrl.collapsed class=\"translated-text with-linebreaks\">{{ $ctrl.text }}</p> ";


//////////////////
// WEBPACK FOOTER
// /app/suissealpine/static/app/widgets/i18n/toggletranslatedtext_partial.html
// module id = 547
// module chunks = 0